<template>
  <v-img
    :src="svgPath"
    :width="svgSize"
    :height="svgSize"
  />
</template>

<script>
import { computed } from 'vue'

export default {
  name: "UiIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 24 }
  },
  setup(props, { emit }) {
    const svgPath = computed(() => `./style/img/icons/${props.name}.svg`)
    const svgSize = computed(() => props.size)

    return {
      svgPath,
      svgSize
    };
  },
};
</script>

<style scoped></style>
